import React from 'react';
import Button from '@/components/Button/Button';
import classes from './PreviousButton.module.scss';

const PreviousButton = ({ additionalClasses, action, text }, ...props) => {
  return (
    <Button
      type="link"
      onButtonClick={action}
      additionalClasses={[`${additionalClasses} ${classes.previousBtn}`]}
      icon={{ style: 'fas', font: 'caret-left', position: 'left' }}
      styles={{ text: 'underline' }}
      text={text}
      dataCy={'button-previous'}
    />
  );
};

export default PreviousButton;
